// @ts-nocheck

import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const colorScienceBlue100: string = '#006bb8';
const colorAzureRadiance100: string = '#0094ff';
const colorAzureRadiance40: string = 'rgba(0, 148, 255, 0.4)';
const colorMineShaft100: string = '#222';
const colorMillionGrey100: string = '#999';
const colorLighthouse100: string = '#f4f4f4';
const colorStratos100: string = '#001643';
const colortransparent10: string = 'rgba(245, 245, 245, 0.1)';
const colortransparent20: string = 'rgba(255, 255, 255, 0.2)';
const colorBlack100: string = '#000000';
const colorBlack20: string = '#00000033';
const colorWhite100: string = '#fff';
const colorBaslerOrangeRed: string = '#ff5252';

const BaslerPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    },
    focusRing: {
      width: '2px',
      offset: '1px',
      color: colorAzureRadiance100,
      ringShadow: '0 0 0 0.1rem ' + colorAzureRadiance100
    },
    colorScheme: {
      light: {
        primary: {
          color: colorAzureRadiance100,
          inverseColor: colorWhite100,
          hoverColor: colorAzureRadiance40,
          activeColor: colorAzureRadiance100
        },
        formField: {
          borderColor: colorMillionGrey100,
          hoverBorderColor: colorBlack20,
          focusBorderColor: colorAzureRadiance100,
          invalidBorderColor: colorBaslerOrangeRed
        }
      },
      dark: {
        primary: {
          color: colorWhite100,
          inverseColor: colorBlack100,
          hoverColor: colorLighthouse100,
          activeColor: colorLighthouse100
        },
        formField: {
          borderColor: colorWhite100,
          hoverBorderColor: colorAzureRadiance100,
          focusBorderColor: colorAzureRadiance100,
          invalidBorderColor: colorBaslerOrangeRed
        }
      }
    }
  },
  components: {
    checkbox: {
      background: 'none',
      checkedBackground: colorAzureRadiance100,
      checkedHoverBackground: colorScienceBlue100,
      checkedBorderColor: colorAzureRadiance100,
      checkedHoverBorderColor: colorScienceBlue100,
      iconSize: '14px',
      iconCheckedColor: colorWhite100,
      iconCheckedHoverColor: colorWhite100,
      colorScheme: {
        light: {
          borderColor: colorMillionGrey100,
          hoverBorderColor: colorBlack20
        },

        dark: {
          borderColor: colorWhite100,
          hoverBorderColor: colorAzureRadiance100
        }
      }
    },
    radiobutton: {
      background: 'none',
      checkedBackground: 'none',
      checkedHoverBackground: 'none',
      checkedBorderColor: colorAzureRadiance100,
      checkedHoverBorderColor: colorScienceBlue100,
      iconSize: '12px',
      iconCheckedColor: colorAzureRadiance100,
      iconCheckedHoverColor: colorScienceBlue100,
      colorScheme: {
        light: {
          borderColor: colorMillionGrey100,
          borderHoverColor: colorBlack20
        },

        dark: {
          borderColor: colorWhite100,
          borderHoverColor: colorMillionGrey100
        }
      }
    },
    select: {
      listGap: '0.25rem',
      filledBackground: colorLighthouse100,
      filledFocusBackground: colorLighthouse100,
      filledHoverBackground: colorLighthouse100,
      borderRadius: '8px',
      focusBorderColor: colorAzureRadiance100,
      hoverBorderColor: colorAzureRadiance100,
      focusRingShadow: '0 0 0 0.1rem ' + colorAzureRadiance100,
      dropdownWidth: '30px',
      optionSelectedBackground: colorAzureRadiance100,
      optionSelectedFocusBackground: colorAzureRadiance100,
      optionSelectedFocusColor: colorWhite100,
      optionSelectedColor: colorWhite100,
      optionFocusBackground: colorAzureRadiance40,
      optionFocusColor: colorWhite100,
      optionBorderRadius: '8px',
      optionPadding: '5px 10px',
      overlayBorderRadius: '8px',
      overlayBackground: colorLighthouse100,
      listHeaderPadding: '0.625rem 1rem 0.625rem 1rem',
      colorScheme: {
        dark: {
          color: colorWhite100,
          optionColor: colorWhite100,
          focusBorderColor: 'rgba(0, 0, 0, 0)',
          dropdownColor: colorWhite100,
          filledFocusBackground: colortransparent20,
          filledHoverBackground: colortransparent20,
          filledBackground: colortransparent10,
          optionSelectedBackground: colortransparent20,
          optionSelectedFocusBackground: colortransparent10,
          optionFocusBackground: colortransparent10
        }
      }
    },
    slider: {
      trackBackground: colorBlack20,
      rangeBackground: colorAzureRadiance100,
      trackSize: '7px',
      handleContentHoverBackground: colorWhite100,
      handleContentWidth: '14px',
      handleContentHeight: '14px'
    },
    floatlabel: {
      color: colorMillionGrey100,
      focusColor: colorMineShaft100,
      colorScheme: {
        dark: {
          activeColor: colorWhite100,
          focusColor: colorLighthouse100,
          onActiveBackground: colorStratos100
        }
      }
    },
    datatable: {
      borderColor: colorLighthouse100,
      headerBackground: 'none',
      headerCellBackground: 'none',
      headerCellHoverBackground: 'none',
      rowBackground: 'none',
      rowHoverBackground: colorLighthouse100,
      rowSelectedBackground: colorAzureRadiance100,
      rowSelectedColor: colorWhite100,
      paginatorBottomBorderWidth: '0px'
    },

    inputtext: {
      borderColor: colorBlack100,
      hoverBorderColor: colorMineShaft100,
      focusBorderColor: colorAzureRadiance100,
      focusRingShadow: '0 0 0 0.1rem ' + colorAzureRadiance100,
      placeholderColor: colorMillionGrey100,
      disabledBackground: colorLighthouse100,
      invalidBorderColor: colorBaslerOrangeRed,
      colorScheme: {
        dark: {
          background: 'none',
          disabledBackground: 'none',
          color: colorWhite100,
          borderColor: colorLighthouse100,
          hoverBorderColor: colorAzureRadiance100,
          placeholderColor: colorWhite100
        }
      }
    },
    inputnumber: {
      buttonWidth: '20px'
    },
    tieredmenu: {
      borderRadius: '20px',
      listPadding: '20px',
      listGap: '2',
      itemPadding: '5px',
      itemGap: '2',
      itemFocusBackground: colorLighthouse100,
      itemActiveBackground: colorLighthouse100
    }
  }
});

export default {
  preset: BaslerPreset,
  options: {
    prefix: 'p',
    darkModeSelector: '.theme-dark',
    cssLayer: false
  }
};
